export const enum SocialLoginProvider {
  APPLE = 'apple'
}
